import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { collection, getDocs, query, where } from "firebase/firestore/lite";
import { db } from "../firebase.config";
import Loading from "../components/extra/Loading";

function Orders() {
  const userInfo = useSelector((state) => state.shopsyReducer.userInfo);
  console.log(userInfo);
  const [ user, setUser ] = useState(true)
  const [ loading, setLoading ] = useState(true)
  const [ orders, setOrders ] = useState([])
  
  useEffect(() => {
    if(userInfo){
    const uid = userInfo._id
    const getOrders = async (uid) => {
      const ordersData = [];

      // Create a reference to the user document with the specified UID
      const userRef = collection(db, "users");
      const q = query(userRef, where("uid", "==", uid));
      const userSnapshot = await getDocs(q);

      // Get the orders subcollection of the current user
      const ordersRef = collection(userSnapshot.docs[0].ref, "orders");
      const ordersSnapshot = await getDocs(ordersRef);

      // Loop through each order document and add it to the ordersData array
      ordersSnapshot.forEach((orderDoc) => {
        ordersData.push({
          orderId: orderDoc.id,
          orderData: orderDoc.data(),
        });
      });
      setOrders(ordersData)
      setLoading(false)
      console.log("Orders for user with UID", uid, ":", ordersData);
      return ordersData;
    };
    getOrders(uid)
  }else{
    setUser(false)
  }
  },[userInfo]);
  console.log("odrs: ",orders)
  
  const navigate = useNavigate()
  const goToOrderDetails = (oid,time,total,payment,items) => {
    console.log();
    const payload = {
      time:time.toDate().toLocaleString(),
      total:total,
      payment:payment,
      items:items
    }
    navigate(`/order/${oid}`,{
      state:{
        cargo: payload
      }});
  }

  return (
    <div className="pb-5">
      <div className="px-4 py-4 mb-8">
        {user ? "" : "Plese logIn to continue"}
        {user && loading ? <Loading/> : ""}
        {orders.length === 0
          ? ""
          : orders.map((order, index) => (
              <div
              onClick={ ()=> goToOrderDetails(
                order.orderId,
                order.orderData.server, 
                order.orderData.total,
                order.orderData.payment,
                order.orderData.items,

                ) }
               
                key={order.orderId}
                style={{ minWidth: "10rem" }}
                className="flex flex-col  mb-3  bg-white border border-gray-200 rounded-lg shadow  md:max-w-xl hover:bg-slate-100 dark:border-slate-700 dark:bg-slate-800 dark:hover:bg-slate-700"
              >
                <div className="flex flex-row">
                  <div className="flex flex-col gap-1">
                    {order.orderData.items.map((item) => (
                      <img
                        class="object-cover w-32 h-32 rounded-t-lg rounded-lg md:rounded-l-lg"
                        src={item.image}
                        alt="prodImg"
                      />
                    ))}
                  </div>
                  <div class="flex flex-col flex-1  justify-between pl-3 leading-normal">
                    {order.orderData.items.map((item) => (
                      <h5 className="mb-auto font-bold mt-3 text-lg text-gray-900 dark:text-white">
                        <span className="w-2">{item.title.substring(0,20)}{item.title.length >= 22 ? "..": ""}</span> <br />
                        <span className="font-normal tracking-widest text-sm text-slate-400">
                          Qty: {item.quantity}
                        </span>
                      </h5>
                    ))}
                  </div>
                </div>
                <div className="flex justify-end text-end pr-3 text-sm">
                  <p className="mb-3 font-normal text-slate-800 dark:text-slate-400 mt-[-4rem] self-end">
                    Ordered on <br/> {order.orderData.server ? order.orderData.server.toDate().toLocaleString(): "Unavailable"}
                  </p>
                </div>
              </div>
            ))}
        {loading === false && orders.length === 0 ? (
          <div className="flex items-center w-{95vw">
            <p className="text-center text-purple-900 font-semibold text-lg">
              You haven't Orderd anything yet
            </p>
          </div>
        ) : (
          ""
        )}
        
      </div>
    </div>
  );
}

export default Orders;
